import ToggleItem from './toggle_item';

export default class Print extends ToggleItem {
  constructor() {
    super('exportconfig');
  }
}